import type { FC, PropsWithChildren } from 'react';
import React, { useContext } from 'react';

import { AppContext } from '../../capabilities/contextStore/AppContext';

const ConditionalAppContentVisibility: FC<PropsWithChildren> = ({
  children,
}) => {
  const { overlayLoaderConfig } = useContext(AppContext);

  return (
    <div
      style={{
        display: overlayLoaderConfig.show ? 'none' : 'block',
      }}
    >
      {children}
    </div>
  );
};

export default ConditionalAppContentVisibility;
